"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.skZones = void 0;
var skZones = exports.skZones = [{
  id: 'BRATISLAVA',
  name: 'Bratislava',
  country: 'SK',
  cornerNW: {
    latitude: 48.2285,
    longitude: 16.9723
  },
  cornerSE: {
    latitude: 48.0524,
    longitude: 17.2095
  },
  subZones: [{
    name: 'Bratislava Centre historique',
    zipcodes: {
      81000: {
        label: '81000'
      }
    }
  }, {
    name: 'Bratislava Rača',
    zipcodes: {
      83101: {
        label: '83101'
      }
    }
  }, {
    name: 'Bratislava Dúbravka',
    zipcodes: {
      84101: {
        label: '84101'
      }
    }
  }, {
    name: 'Bratislava Petržalka',
    zipcodes: {
      85101: {
        label: '85101'
      }
    }
  }]
}];